let config = {};

try {
  config = JSON.parse(process.env.ENVIRONMENT_VARIABLES || '');
} catch (error) {
  console.log('Error parsing environment variables');
}

export default config;
